import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class MachineSearchTask extends GenericRequest {

    _request; // MachineSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MACHINES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/list/machine-search/MachineSearchTask.js